/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Box } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { FC } from "react";

export const CarrierPaymentCompleted: FC<{
  isDarkModeEnabled: boolean;
}> = ({ isDarkModeEnabled }) => {
  const { t } = useI18n();

  return (
    <Box
      component={"div"}
      display={"flex"}
      flexDirection={"column"}
      gridGap={"20px"}
    >
      <Box
        component={"h2"}
        fontWeight={"700"}
        textAlign={"center"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
      >
        {t("streaming.commerceModal.doneHeadline")}
      </Box>

      <Box
        component={"p"}
        fontSize={"14px"}
        lineHeight={"1.5em"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
      >
        {t("streaming.commerceModal.donePara")}
      </Box>

      <Box
        component={"p"}
        fontSize={"12px"}
        fontWeight={"700"}
        lineHeight={"1.5em"}
        color={isDarkModeEnabled ? "#fff" : "#000"}
      >
        {t("streaming.commerceModal.doneCaution")}
      </Box>
    </Box>
  );
};
